import ThemeContext from '../theme/theme-context.js';
import useSportsbookLocation from '~/hooks/use-sportsbook-location';
import useCasinoLocation from '~/hooks/use-casino-location';

const CustomHeaderLogoMobile = ({ isDesktop }) => {
	const { isSportsbookLocation } = useSportsbookLocation();
	const { isCasinoLocation, isLiveCasinoLocation } = useCasinoLocation();
	if (isCasinoLocation || isLiveCasinoLocation) {
		return (
			<div>
				<ThemeContext.Consumer>
					{({ LogoCasino }) => <LogoCasino isDesktop={isDesktop} />}
				</ThemeContext.Consumer>
			</div>
		);
	}
	if (isSportsbookLocation) {
		return (
			<div>
				<ThemeContext.Consumer>
					{({ LogoSports }) => <LogoSports isDesktop={isDesktop} />}
				</ThemeContext.Consumer>
			</div>
		);
	}
	return (
		<div>
			<ThemeContext.Consumer>{({ Logo }) => <Logo isDesktop={isDesktop} />}</ThemeContext.Consumer>
		</div>
	);
};

export default CustomHeaderLogoMobile;
